import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epsilon-spinner',
  templateUrl: './epsilon-spinner.component.html',
  styleUrls: ['./epsilon-spinner.component.sass']
})
export class EpsilonSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
